export function getPlaceholder(imageData, isErrored, { noImagePlaceholder, noImagePlaceholderStatic, onErrorPlaceholder, onErrorPlaceholderStatic, }) {
    if (!imageData) {
        return { object: noImagePlaceholder, static: noImagePlaceholderStatic };
    }
    if (isErrored) {
        return { object: onErrorPlaceholder, static: onErrorPlaceholderStatic };
    }
    return { object: onErrorPlaceholder, static: onErrorPlaceholderStatic };
}
